import {ServerSideRenderingFeatureFlag} from 'components/ServerSideRenderingFeatureFlag/ServerSideRenderingFeatureFlag'
import dynamic from 'next/dynamic'
import {baseGetServerSideProps} from 'utils/server/defaultGetServerSideProps'

const HomeView = dynamic(() => import(/* webpackPrefetch: true */ 'views/home'))

import {Page} from '@daedalus/core/src/analytics/types/Events'

const HomePage = () => {
  return (
    <ServerSideRenderingFeatureFlag>
      <HomeView />
    </ServerSideRenderingFeatureFlag>
  )
}

export default HomePage

export const getServerSideProps = baseGetServerSideProps({page: Page.Home})
